export default "__VITE_ASSET__db3c8688__"